import React from 'react';
import '../../../assets/css/dashboard.css'
import leftArrowImage from '../../../assets/images/left-arrow.png'

function PageHeader(props) {
    return (
        <div class="col-md-12 px-0 py-2 position-top-stick">
            <div className="col-md-4 nopadding text-left">
                {/* <span className="p-2 cursor-hover" onClick={(e) =>props.history.goBack()} > 
                    <i className="fa fa-arrow-left"></i>
                </span> */}
                <span className="p-2 cursor-hover" onClick={() => {
                    const route = props.history.location.state && props.history.location.state.route
                    route !== undefined ? props.history.push(`/${route}`, {
                        [`${route.toLowerCase()}`]: {
                            ...props.history.location.state[`${route.toLowerCase()}`]
                        }
                    }) : props.history.goBack()
                }} >
                    <img width={"20px"} src={leftArrowImage} />
                </span>
            </div>
            <div className="col-md-4 nopadding text-center">
                <h6>{props.header === "cad" ? "3D" : props.header}</h6>
            </div>
            <div className="col-md-4">
            </div>
        </div >
    )
}

export default PageHeader


// WEBPACK FOOTER //
// ./src/components/Page/PageHeader/PageHeader.js